import { InMemoryObjectBase } from '../../../helpers/in-memory-object';
import { User } from './user';
import { JSONUtilites } from '../../../helpers/JSONUtilites';

export class InMemoryUsers extends InMemoryObjectBase<User> {

  protected get storeKeyName(): string {
    return 'in_memory_users';
  }

  protected _createDemoItems(): User[] {
    return [
      new User({ id: 1, username: 'Admin', login: 'admin', password: 'Test1234', session_id: '1', partner_id: 1 }),
      new User({ id: 2, username: 'Jesica', login: 'test', password: 'Test1234', session_id: '2', partner_id: 2 }),
      new User({ id: 3, username: 'John', login: 'test2', password: 'Test1234', session_id: '3', partner_id: 3 }),
    ];
  }

  protected _FromJSON(json: string): User[] {
    return JSONUtilites.arrayFromJSON(User, json);
  }

  protected _getItemId(item: User): number {
    return item.id;
  }
}

